module.exports = __webpack_public_path__ + "static/img/3.b889634.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/8/zh/3.png
// module id = cmmi
// module chunks = 0